export function effectiveUserPreferenceUrl(userId: number | string, locationId: number | string): string {
  return `/api/users/${userId}/locations/${locationId}/effective_user_preference`;
}

export function effectiveUserPreferencesForClientUrl(userId: number | string, clientId: number | string): string {
  return `/api/users/${userId}/clients/${clientId}/effective_user_preferences`;
}

export function effectiveUserPreferencesUrl(userId: number | string): string {
  return `/api/users/${userId}/effective_user_preferences`;
}
